import RendernModal from './RendernModal';

export default RendernModal;